// @flow

function pickExcept<T: Object>(props: T, except: Object): $Shape<T> {
  return Object.keys(props).reduce((acc, k) => {
    if (!except[k]) {
      acc[k] = props[k]
    }
    return acc
  }, {})
}

export default pickExcept
